import Settings from "../../components/candidate/settings";

const SettingsCandidatePage = () => {
  return <Settings />;
};

export default SettingsCandidatePage;
